import htmlToImage from 'html-to-image';

export const downloadImage = (widgetId: string, widgetName: string) => {
  htmlToImage.toJpeg(document.getElementById(widgetId), { quality: 0.95, backgroundColor: '#fff'})
    .then((dataUrl) => {
      const link = document.createElement('a');

      link.download = `${widgetName}.jpeg`;
      link.href = dataUrl;
      link.click();
    });
}
